import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import cookie from 'vue-cookie'

export default new Vuex.Store({
  state: {
    tokens: {
      access: '',
      refresh: ''
    },
    auth: {
      isUserRoot: true
    },
    wastedLimitItems: null,
    toggleSideBar: false,
    balance: '',
    currency: 'rub',
    itemsExchangeLimit: {},
    currentDailyLimit: {},
    currentBalanceLimit: {},
    permissions: null,
    deleteFraudItems: [],
    deleteRegularPayments: [],
    editingRegularFormOpen: false,
    editingRegularPayment: {},
    currentSpent: {}
  },
  mutations: {
    setTokens(state, tokens) {
      state.tokens.access = tokens.access_token
      state.tokens.refresh = tokens.refresh_token

      cookie.set('token', tokens.access_token)
      cookie.set('refresh', tokens.refresh_token)
    },
    setToggleSideBar(state, value) {
      state.toggleSideBar = value
    },
    setPermissions(state, data) {
      state.permissions = data
    },
    setBalance(state, data) {
      state.balance = data
    },
    setCurrentSpent(state, data) {
      state.currentSpent = data
    },
    setWastedLimitItems(state, data) {
      state.wastedLimitItems = data
    },
    setCurrency(state, value) {
      state.currency = value
    },
    setItemsExchangeLimit(state, data) {
      state.itemsExchangeLimit = data
    },
    setCurrentDailyLimit(state, data) {
      state.currentDailyLimit = data
    },
    setCurrentBalanceLimit(state, data) {
      state.currentBalanceLimit = data
    },
    setEditingRegularFormOpen(state, data) {
      state.editingRegularFormOpen = data
    },
    setEditingRegularPayment(state, data) {
      state.editingRegularPayment = data
    },
    setDeleteFraudItems(state, data) {
      state.deleteFraudItems = data
    },
    setDeleteRegularPayments(state, data) {
      state.deleteRegularPayments = data
    },
    addDeleteFraudItem(state, data) {
      state.deleteFraudItems.push(data)
    },
    addDeleteRegularPayments(state, data) {
      state.deleteRegularPayments.push(data)
    },
    removeDeleteFraudItem(state, data) {
      state.deleteFraudItems.splice(state.deleteFraudItems.indexOf(data), 1)
    },
    removeDeleteRegularPayments(state, data) {
      state.deleteRegularPayments.splice(state.deleteRegularPayments.indexOf(data), 1)
    }
  },
  actions: {
    openSideBar({ commit }) {
      commit('setToggleSideBar', true)
    },
    closeSideBar({ commit }) {
      commit('setToggleSideBar', false)
    },
    getAdminStatus({ commit, state }) {
      return fetch(`https://auth.apineural.com/api/user/admin-status`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${state.tokens.access}`
        }
      })
        .then((res) => {
          if (res.status === 401) {
            cookie.delete('token')
            cookie.delete('refresh')
            window.location.href = 'https://control.starpets.gg/'
          }
          return res.json()
        })
        .then((data) => {
          const accLimit = data.acc_payments_limit
          const itemsLimit = data.items_limit
          const balanceLimit = data.balances_limit
          const permissions = data.permissions ? data.permissions : data
          commit('setCurrentDailyLimit', accLimit)
          commit('setItemsExchangeLimit', itemsLimit)
          commit('setPermissions', permissions)
          commit('setCurrentBalanceLimit', balanceLimit)
        })
    }
  }
})
